module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page",
    attrs: {
      "id": "page-wat-is"
    }
  }, [_c('div', {
    staticClass: "page__content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-2-sm"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-10-sm list-select__title"
  }, [_c('page-next-button', {
    on: {
      "click": _vm.nextHandler
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page-wat-is__intro"
    }
  }, [_c('h1', [_vm._v("Maar wat is een hybride docent?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-2-sm"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-10-sm"
  }, [_c('h2', [_vm._v("Een hybride docent ...")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row page-wat-is__bullet-row"
  }, [_c('div', {
    staticClass: "col-2-sm page-wat-is__arrow-bullet"
  }, [_c('span', {
    staticClass: "fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-10-sm page-wat-is__list-item"
  }, [_c('p', [_vm._v("Combineert gelijktijdig twee of meer (onderwijs)banen of (onderwijs)rollen;")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row page-wat-is__bullet-row"
  }, [_c('div', {
    staticClass: "col-2-sm page-wat-is__arrow-bullet"
  }, [_c('span', {
    staticClass: "fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-10-sm page-wat-is__list-item"
  }, [_c('p', [_vm._v("heeft een hoofdbaan (meeste uren) als docent welke wordt gecombineerd met een baan in loondienst of als zelfstandige;")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row page-wat-is__bullet-row"
  }, [_c('div', {
    staticClass: "col-2-sm page-wat-is__arrow-bullet"
  }, [_c('span', {
    staticClass: "fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-10-sm page-wat-is__list-item"
  }, [_c('p', [_vm._v("of andersom: dan is het docentschap de tweede baan en werkt men in de hoofdbaan elders in loondienst of zelfstandige;")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-2-sm"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-10-sm"
  }, [_c('h2', [_vm._v("En verder:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row page-wat-is__bullet-row"
  }, [_c('div', {
    staticClass: "col-2-sm page-wat-is__arrow-bullet"
  }, [_c('span', {
    staticClass: "fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-10-sm page-wat-is__list-item"
  }, [_c('p', [_vm._v("Hoeveel uur er in meerdere banen wordt gewerkt is niet relevant;")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row page-wat-is__bullet-row"
  }, [_c('div', {
    staticClass: "col-2-sm page-wat-is__arrow-bullet"
  }, [_c('span', {
    staticClass: "fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-10-sm page-wat-is__list-item"
  }, [_c('p', [_vm._v("de contractvorm in elk van de banen is niet relevant;")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row page-wat-is__bullet-row"
  }, [_c('div', {
    staticClass: "col-2-sm page-wat-is__arrow-bullet"
  }, [_c('span', {
    staticClass: "fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-10-sm page-wat-is__list-item"
  }, [_c('p', [_vm._v("het hybride docentschap kan ook een tijdelijke (afgesproken) combinatie zijn, maar gaat verder dan bijvoorbeeld gastdocentschap.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6321fef7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/page-wat-is-1.vue
// module id = 146
// module chunks = 0